import { Droplets, Apple, Cookie, Coffee, Sun, Package } from "lucide-react";

const ITEMS = [
  { icon: Droplets, label: "Water" },
  { icon: Apple, label: "Fruit" },
  { icon: Cookie, label: "Granola Bars" },
  { icon: Package, label: "Juice Boxes" },
  { icon: Sun, label: "Breakfast Bites" },
  { icon: Coffee, label: "Hydration Support" },
];

export default function FuelStation({ onSponsor }) {
  return (
    <section
      id="fuel-station"
      data-testid="section-fuel-station"
      className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="bg-gradient-to-br from-[#00A651]/15 via-black to-[#EC008C]/15 border-2 border-dashed border-[#00A651]/50 p-8 md:p-14">
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 border border-[#00A651]/60 bg-[#00A651]/10 px-3 py-1 mb-4">
                <span className="w-2 h-2 rounded-full bg-[#00A651] animate-pulse" />
                <span className="text-[10px] uppercase tracking-[0.28em] text-[#00A651] font-bold">
                  Official Sponsor Level
                </span>
              </div>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
                Fuel Partners <span className="text-[#EC008C]">&amp; Hydration Sponsors</span>.
              </h2>
              <p className="mt-5 text-lg text-[#E5E5E5] leading-relaxed">
                Fuel Partners (also known as Fuel Station Sponsors and hydration sponsors) keep runners, walkers,
                youth participants, and volunteers going strong. We welcome <strong>water donations</strong> and{" "}
                <strong>snack donations</strong> from local grocery stores, beverage companies, cafés, bakeries,
                health-food brands, and community partners — the small things that turn a good race into an
                unforgettable one.
              </p>

              <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-3">
                {ITEMS.map(({ icon: Icon, label }) => (
                  <div
                    key={label}
                    className="flex items-center gap-3 bg-black/40 border border-[#27272A] px-3 py-2.5 hover:border-[#EC008C]/60 transition-colors"
                  >
                    <Icon className="w-5 h-5 text-[#00A651] shrink-0" />
                    <span className="text-sm font-semibold text-white uppercase tracking-wide">{label}</span>
                  </div>
                ))}
              </div>

              <button
                onClick={onSponsor}
                data-testid="fuel-station-btn"
                className="mt-8 bg-[#00A651] hover:bg-[#1FBF3E] text-black font-bold uppercase tracking-widest text-sm px-8 py-4 transition-all hover:-translate-y-0.5"
              >
                Become a Fuel Partner →
              </button>
              <p className="mt-4 text-sm text-[#A3A3A3] max-w-2xl">
                Local grocery stores, beverage companies, health-food brands, snack companies, cafés, bakeries, and
                hydration sponsors — this is how you plug in.
              </p>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-black border border-[#27272A] p-6 md:p-8 relative">
                <div className="absolute -top-3 left-6 bg-[#0A0A0A] px-3">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-[#EC008C] font-bold">
                    How it works
                  </span>
                </div>
                <ol className="space-y-4 text-sm text-[#E5E5E5]">
                  {[
                    "Pledge a category (e.g., water, granola bars, fruit) or a dollar amount.",
                    "Your logo appears on the Fuel Station banner and race-day signage.",
                    "Social media shoutout to runners: \"Powered by [Your Brand].\"",
                    "Vendor table option at the Fuel Station on race day.",
                  ].map((step, i) => (
                    <li key={i} className="flex gap-3">
                      <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#EC008C] text-white flex items-center justify-center font-display font-black text-sm">
                        {i + 1}
                      </span>
                      <span className="pt-0.5">{step}</span>
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
